exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading #header div,.loading #header h1{display:none}", "", {"version":3,"sources":["/src/Glow/frontend/src/components/organisms/Header/styles.css"],"names":[],"mappings":"AAAA,yCAEE,YAAc,CACf","file":"styles.css","sourcesContent":[".loading #header div,\n.loading #header h1 {\n  display: none;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/organisms/Header/styles.css
// module id = 1745
// module chunks = 0